"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.abImpression = void 0;
var consts_1 = require("../consts");
var abImpression = function (event) {
    var _a, _b, _c, _d, _e, _f;
    return {
        event: "abimpression",
        eventInfo: "abimpression",
        action: "abimpression",
        ab: {
            testName: (_b = (_a = event.eventData) === null || _a === void 0 ? void 0 : _a.ab) === null || _b === void 0 ? void 0 : _b.testName,
            experienceName: (_d = (_c = event.eventData) === null || _c === void 0 ? void 0 : _c.ab) === null || _d === void 0 ? void 0 : _d.experienceName,
            status: ((_f = (_e = event.eventData) === null || _e === void 0 ? void 0 : _e.ab) === null || _f === void 0 ? void 0 : _f.status) || consts_1.NOT_AVAILABLE,
        },
    };
};
exports.abImpression = abImpression;
